import { action, decorate, observable } from "mobx";

import {
    getTopupInfo
} from "../services/TopupBitcoinService";

class TopupBitcoinStore {
    isLoading = false;
    topUpInfo = {};

    getTopupInfo = async (walletId) => {
        this.isLoading = true;
        
        const postData = {
            address: walletId,
            currenncy: "BTC"
        }

        const { data, error } = await getTopupInfo(postData);
    
        if (data) {
            this.topUpInfo = data;
            this.isLoading = false;
            return { data };
        } else {

            this.isLoading = false;
            return { error };
        }
    }
}

decorate(TopupBitcoinStore, {
    isLoading: observable,
    topUpInfo: observable,
    getTopupInfo: action
});
export default new TopupBitcoinStore();
